import { render, staticRenderFns } from "./AirPortTicketInfo.vue?vue&type=template&id=caaf2154&scoped=true"
import script from "./AirPortTicketInfo.vue?vue&type=script&lang=ts"
export * from "./AirPortTicketInfo.vue?vue&type=script&lang=ts"
import style0 from "./AirPortTicketInfo.vue?vue&type=style&index=0&id=caaf2154&prod&scoped=true&lang=scss"
import style1 from "./AirPortTicketInfo.vue?vue&type=style&index=1&id=caaf2154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaf2154",
  null
  
)

export default component.exports